import { useTranslation } from "react-i18next";
import { TabItem } from "./View/styles";
import { tabTitles } from "./tab-titles";

interface TabTitleProps {
    tab: number;
    setTab: (id: number) => void;
    currentTab: number;
};

const TabTitle: React.FC<TabTitleProps> = ({ tab, setTab, currentTab }) => {
    const [t] = useTranslation();
    return <TabItem active={currentTab === tab} onClick={() => setTab(tab)} >
        {t(`ru.halls.tabs.${tabTitles[tab]}`)}
    </TabItem>;
}

export default TabTitle;